module.exports = __webpack_public_path__ + "img/completed.40344c62.svg";